import { useSelector } from 'react-redux';
import constants from '@/core/constants';

export const useNewLocations = () => {
  const { academic } = useSelector((state: any) => state.profile?.data);
  const isNewLocation = new Set(constants.NEW_LOCATIONS).has(academic.campus);
  return { isNewLocation };
};
